<template>
  <ht-org-selector
    v-model="value"
    :validate="validate"
    :name="inputName"
    :placeholder="placeholder"
    :permission="permission_sub"
    :single="single"
    :config="config"
    :data="data"
    :table-columns="tableColumns"
    :pagination="pagination"
    :demensions="demensions"
    :default-demension="defaultDemension"
    :orgs="orgs"
    :load-org-tree="loadOrgTree"
    :append-to-body="appendToBody"
    @load="handleLoad"
    @valueChange="valueChange"
    @changeDemension="changeDemension"
    @loadDemensions="loadDemensions"
    @loadOrgs="loadOrgs"
    select-label="name"
    quick-search-props="name,code"
  >
    <span style="display:none;"  v-validate>
	  <slot name="labeldesc">{{inputName}}</slot>
	</span>
  </ht-org-selector>
</template>
<script>
import utils from "@/hotent-ui-util.js";
import sub_pio_mixin from "@/sub-permission-mixin.js";

export default {
  name: "eip-org-selector",
  props: {
    validate: [String, Object],
    value: String,
    name: String,
    placeholder: String,
    permission: String,
    single: Boolean,
    config: Object,
    appendToBody: {
      type: Boolean,
      default: false
    },
    selectCurrent: Boolean
  },
  mixins: [sub_pio_mixin],//混入方式引入表单组件，处理子表点击当前行可编辑（切面修改permission）
  data() {
    return {
      data: [],
      demensions: [],
      defaultDemension: "",
      orgs: [],
      tableColumns: [
        { prop: "name", label: "名称",width:"120" },
        // { prop: "code", label: "编码" },
        { prop: "pathName", label: "路径"}
      ],
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      orgLength: 0
    };
  },
  computed:{
    inputName: function() {
      let labeldesc = "";
      if(this.$slots && this.$slots.labeldesc && this.$slots.labeldesc[0].children && this.$slots.labeldesc[0].children[0].text){
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName()+ "-" +labeldesc;
      }else{
        return this.name ? this.name : utils.getName();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 没有值而且需要显示当前组织
      if (!this.value && this.selectCurrent) {
        let org = null;
        if (this.$store.state.user.currentOrgDetail == null) {
          this.$store
            .dispatch("user/loadCurrentUserDetail")
            .then(currentOrgDetail => {
              for (let key in currentOrgDetail.org) {
                org = currentOrgDetail.org[key];
              }
            })
            .then(() => {
              this.initCurrentOrg(org);
            });
        } else {
          for (let key in this.$store.state.user.currentUserDetail.org) {
            org = this.$store.state.user.currentUserDetail.org[key];
          }
          this.initCurrentOrg(org);
        }
      }
    });
  },
  methods: {
    initCurrentOrg(org) {
      if (org && this.config) {
        // 配置了id的绑定关系，则回填到指定属性上
        if (this.config.hasOwnProperty("id")) {
          utils.setValueByConfigKey(this, this.config, "id", org.orgid);
        }
        // 配置了code的绑定关系，则回填到指定的属性上
        if (this.config.hasOwnProperty("code")) {
          utils.setValueByConfigKey(this, this.config, "code", org.orgcode);
        }
        // 配置了name的绑定关系，则回填到指定的属性上
        if (this.config.hasOwnProperty("name")) {
          utils.setValueByConfigKey(this, this.config, "name", org.orgname);
        }
      }
      org && setTimeout(()=>{
        this.$emit("input", org.orgname);
      })
    },
    handleLoad(param, cb) {
      let _this = this;
      this.$http
        .post("${uc}/api/org/v1/orgs/getOrgPage", param)
        .then(function(response) {
          let data = response.data;
          _this.data = data.rows;
          _this.pagination.page = data.page;
          _this.pagination.pageSize = data.pageSize;
          _this.pagination.total = data.total;
        })
        .finally(err => {
          cb();
        });
    },
    valueChange(value) {
      this.$emit("input", value);
    },
    loadOrgTree(node, resolve) {
      if (node && node.data && node.data.isParent) {
        if (node.data.children) {
          resolve(node.data.children);
        } else {
          this.$http
            .post("${uc}/api/org/v1/orgs/getByParentAndDem", {
              demId: node.data.demId,
              parentId: node.data.id
            })
            .then(function(rep) {
              resolve(rep.data);
            })
            .catch(function(error) {});
        }
      } else {
        resolve([]);
      }
    },
    changeDemension(currentDemensionId) {
      // 维度改变 重新获取组织
      let _this = this;
      this.$http
        .post("${uc}/api/org/v1/orgs/getByParentAndDem", {
          demId: currentDemensionId
        })
        .then(function(rep) {
          _this.orgs = utils.tile2nest(rep.data);
        })
        .catch(function(error) {});
    },
    loadOrgs(org) {
      // 获取当前组织及下级组织
      let queryFilter = {
        pageBean: this.pagination,
        querys: []
      };
      let query = {
        property: "path",
        value: org.path,
        group: "main",
        operation: "RIGHT_LIKE",
        relation: "AND"
      };
      queryFilter.querys.push(query);
      this.handleLoad(queryFilter, () => {});
    },
    loadDemensions() {
      if (this.demensions.length == 0) {
        let _this = this;
        this.$http
          .get("${uc}/api/demension/v1/dems/getAll")
          .then(function(rep) {
            let data = rep.data;
            _this.demensions = data;
            _this.defaultDemension = data[0].id;
          })
          .catch(function(error) {});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .dialog-selector__wrapper .el-dialog .el-dialog__title{
    font-weight:bold;
    font-size: 12px;
}
/deep/ .cell{
  text-align:left;
}
/deep/ .el-tree-node__label {
  font-size: 12px;
}
</style>